/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import { isEmpty, truncate } from 'lodash'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { Loader } from '@/components/loaders/Loader'
import { Pill } from '@/components/pills/Pill'

export const shortenMultipleSelectedHover = (selectedList, selectedWording = 'selected') => {
  if (isEmpty(selectedList)) {
    return { value: '', as: <></> }
  }

  if (React.isValidElement(selectedList[0])) {
    return <Loader size="small" />
  }

  if (selectedList.length === 1) {
    const text = selectedList[0]

    if (selectedWording === 'tags') {
      return {
        value: text,
        as: (
          <InteractiveTooltip interactive content={text} hide={text?.length < 25}>
            <Pill small>{truncate(text, { length: 25 })}</Pill>
          </InteractiveTooltip>
        ),
      }
    }

    return {
      value: text,
      as: (
        <InteractiveTooltip content={text} hide={text?.length < 25}>
          {truncate(text, { length: 25 })}
        </InteractiveTooltip>
      ),
    }
  }

  let hoverString = selectedList[0]
  let endingString = ''
  let maxElements
  if (selectedList.length < 14) {
    maxElements = selectedList.length
  } else {
    endingString += `, +${selectedList.length - 14} more`
    maxElements = 14
  }
  for (let i = 1; i < maxElements; i++) {
    hoverString += `, ${selectedList[i]}`
  }
  hoverString += endingString
  const displayValue = `${selectedList.length} ${selectedWording}`

  return {
    value: displayValue,
    as: (
      <InteractiveTooltip interactive content={hoverString}>
        <Pill small>{displayValue}</Pill>
      </InteractiveTooltip>
    ),
  }
}
